import React from "react";
import {
    Box,
    Typography,
    Container,
    Grid,
    Link,
    IconButton,
    Divider,
    useMediaQuery,
    Tooltip,
    List,
    ListItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
    LinkedIn,
    Twitter,
    WhatsApp,
    Email,
    Phone,
} from "@mui/icons-material";

function TermsOfUse() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
            {/* Social Icons Floating */}
            {/* <Box
                sx={{
                    position: "fixed",
                    top: "30%",
                    right: 16,
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }}
            >
                <Tooltip title="+91 9000316721" placement="left">
                    <IconButton
                        component="a"
                        href="tel:+919000316721"
                        sx={{ bgcolor: "#030366", color: "white", "&:hover": { bgcolor: "#0d47a1" } }}
                    >
                        <Phone fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="info@vensyx.com" placement="left">
                    <IconButton
                        component="a"
                        href="mailto:info@vensyx.com"
                        sx={{ bgcolor: "#030366", color: "white", "&:hover": { bgcolor: "#0d47a1" } }}
                    >
                        <Email fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="LinkedIn" placement="left">
                    <IconButton
                        component="a"
                        href="https://www.linkedin.com/company/vensyx-data-solutions-pvt-ltd-/about/"
                        target="_blank"
                        sx={{ bgcolor: "#0a66c2", color: "white", "&:hover": { bgcolor: "#004182" } }}
                    >
                        <LinkedIn fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Twitter" placement="left">
                    <IconButton
                        component="a"
                        href="https://twitter.com/vensyx2014"
                        target="_blank"
                        sx={{ bgcolor: "#1DA1F2", color: "white", "&:hover": { bgcolor: "#0d8ce0" } }}
                    >
                        <Twitter fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="WhatsApp" placement="left">
                    <IconButton
                        component="a"
                        href="https://wa.me/+919000316721"
                        target="_blank"
                        sx={{ bgcolor: "#25D366", color: "white", "&:hover": { bgcolor: "#1ebe5b" } }}
                    >
                        <WhatsApp fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box> */}

            {/* Content */}
            <Container maxWidth="lg" sx={{ py: 2 }}>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Terms and Conditions
                </Typography>

                <Typography variant="h5" gutterBottom>
                    WELCOME TO VENSYX DATA SOLUTIONS!
                </Typography>

                <Typography paragraph textAlign="justify">
                    These terms and conditions outline the rules and regulations for the use of VENSYX DATA SOLUTIONS Pvt Ltd's Website, located at www.vensyx.com OR VENSYX Data Solutions OR Contents of VENSYX Data Solutions
                    By accessing this website we assume you accept these terms and conditions. Do not continue to use VENSYX DATA SOLUTIONS if you do not agree to take all of the terms and conditions stated on this page.
                    The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Republic Of India. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Cookies
                </Typography>
                <Typography paragraph textAlign="justify">
                    We employ the use of cookies. By accessing VENSYX DATA SOLUTIONS, you agreed to use cookies in agreement with the VENSYX DATA SOLUTIONS Pvt Ltd's Privacy Policy.
                </Typography>
                <Typography paragraph textAlign="justify">
                    Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    License
                </Typography>
                <Typography paragraph textAlign="justify">
                    Unless otherwise stated, VENSYX DATA SOLUTIONS Pvt Ltd and/or its licensors own the intellectual property rights for all material on VENSYX DATA SOLUTIONS. All intellectual property rights are reserved. You may access this from VENSYX DATA SOLUTIONS for your own personal use subjected to restrictions set in these terms and conditions.
                </Typography>
                <Typography paragraph textAlign="justify">
                    You must not:
                </Typography>
                <List>
                    {[
                        "Republish material from VENSYX DATA SOLUTIONS",
                        "Sell, rent or sub-license material from VENSYX DATA SOLUTIONS",
                        "Reproduce, duplicate or copy material from VENSYX DATA SOLUTIONS",
                        "Redistribute content from VENSYX DATA SOLUTIONS"
                    ].map((item, i) => (
                        <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                            {item}
                        </ListItem>
                    ))}
                </List>
                <Typography>
                    This Agreement shall begin on the date hereof.
                </Typography>
                <Typography>
                    Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. VENSYX DATA SOLUTIONS Pvt Ltd does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of VENSYX DATA SOLUTIONS Pvt Ltd,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, VENSYX DATA SOLUTIONS Pvt Ltd shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
                </Typography>
                <Typography>
                    VENSYX DATA SOLUTIONS Pvt Ltd reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.
                </Typography>
                <Typography>
                    You warrant and represent that:
                </Typography>
                <List>
                    {[
                        "The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party",
                        "The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy",
                        "The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity."
                    ].map((item, i) => (
                        <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                            {item}
                        </ListItem>
                    ))}
                </List>
                <Typography>
                    You hereby grant VENSYX DATA SOLUTIONS Pvt Ltd a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Hyperlinking to our Content
                </Typography>
                <Typography paragraph textAlign="justify">
                    The following organizations may link to our Website without prior written approval:
                </Typography>
                <List>
                    {[
                        "Government agencies;",
                        "Search engines;",
                        "News organizations;",
                        "Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and",
                        "System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site."
                    ].map((item, i) => (
                        <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                            {item}
                        </ListItem>
                    ))}
                </List>
                <Typography>
                    These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party’s site.
                </Typography>
                <Typography paragraph textAlign="justify">
                    We may consider and approve other link requests from the following types of organizations:
                </Typography>
                <List>
                    {[
                        "commonly-known consumer and/or business information sources;",
                        "dot.com community sites;",
                        "associations or other groups representing charities;",
                        "online directory distributors;",
                        "internet portals;",
                        "accounting, law and consulting firms; and",
                        "educational institutions and trade associations."
                    ].map((item, i) => (
                        <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                            {item}
                        </ListItem>
                    ))}
                </List>
                <Typography>
                    We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavourably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; and (c) the link is in the context of general resource information.
                </Typography>
                <Typography>
                    These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party’s site.
                </Typography>
                <Typography>
                    If your organization is interested in linking to our website, you must inform us by sending an e-mail to VENSYX DATA SOLUTIONS Pvt Ltd. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.
                </Typography>
                <Typography>
                    No use of VENSYX DATA SOLUTIONS Pvt Ltd's logo or other artwork will be allowed for linking in the absence of a trademark license agreement.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    iFrames
                </Typography>
                <Typography>
                    Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Content Liability
                </Typography>
                <Typography>
                    We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libellous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Your Privacy
                </Typography>
                <Typography>
                    Please read Privacy Policy
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Reservation of Rights
                </Typography>
                <Typography>
                    We reserve the right to request that you remove all links or any particular link to our Website. You should immediately remove all links to our Website upon request. We also reserve the right to amend these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Removal of links from our website
                </Typography>
                <Typography>
                    If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.
                </Typography>
                <Typography>
                    We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Disclaimer
                </Typography>
                <Typography>
                    As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.
                </Typography>
            </Container>
        </>
    );
}

export default TermsOfUse;
